import { services } from "../../../api";
import { NewsItem, Tab } from "../../../interfaces/api/congresses";

/**
 * Get filtered tabs data
 * @returns {Promise<Tab[]>} Array of filtered tabs, returns empty array on error
 */
export const getFilters = async (): Promise<Tab[]> => {
    try {
        const res = await services.tabs.getFilters();
        if (res.result !== 'success') {
            throw new Error('error');
        }
        const removedItems = [5, 9, 10, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
        const data = (res.content?.data || []).filter(item => !removedItems.includes(item.id));
        return data;
    } catch (ex) {
        return [];
    }
}

/**
 * Get news details by ID
 * @param {number} id - The ID of the news item to fetch
 * @returns {Promise<NewsItem | null>} News item details, returns null on error
 */
export const getNewsDetails = async (id: number): Promise<null | NewsItem> => {
    try {
        const res = await services.tabs.getNewsDetails(id);
        if (res.result !== 'success') {
            throw new Error('error');
        }
        return res.content;
    } catch (ex) {
        return null;
    }
}

export const getNews = async (
    tab_id: number,
    pageSize: number,
    page: number,
    filters: Record<string, any>
) => {
    try {
        const res = await services.tabs.getNews({
            pageSize,
            page,
            tab_id,
            ...filters
        });
        return res;
    } catch (ex) {
        // Optionally handle/log the error
        return null;
    }
}